import React from 'react'
import styled from 'styled-components'
import { Col } from 'react-bootstrap'
import { _ } from 'utils'
import { Divider, CardHeader } from 'components'
import { EventLanguage } from 'generated/graphql'
import InfoTooltip from 'components/InfoTooltip'
import constants from 'constants/constants'
import TextField from 'features/forms/components/TextField'
import SelectField from 'features/forms/components/SelectField'
import FileUpload, { IMAGE_ONLY } from 'features/forms/components/FileUpload'
import ColorField from 'features/forms/components/ColorField'
import Switch from 'features/forms/components/Switch'
import Editor from 'features/forms/components/Editor'

const S = {
    Header: styled(CardHeader)`
        display: flex;
        align-items: center;
        margin: 20px 10px;
    `,
    AutostartVideoSwitch: styled(Switch)`
        padding-top: 38px;
    `
}

const languageOptions: { label: EventLanguage, value: EventLanguage }[] = [
    { label: EventLanguage.English, value: EventLanguage.English },
    { label: EventLanguage.Dutch, value: EventLanguage.Dutch },
    { label: EventLanguage.German, value: EventLanguage.German },
]

const Communication = () => {
    const isLite = constants.isLite

    return (
        <>
            <SelectField
                label={_('generalsettings.form.language')}
                helperText={_('generalsettings.form.language_helper_text')}
                name="language"
                options={languageOptions}
                lg={1/2}
                isClearable={false}
            />
            <TextField
                name="virtual.goodiebagName"
                isRequired
                label={_('generalsettings.form.goodiebag_name')}
                helperText={_('generalsettings.form.goodiebag_name_helper_text')}
                showInfoIcon
                lg={1/2}
            />
            <Divider extend={10} />
            <S.Header>
                {_('generalsettings.form.branding_header')}
                <InfoTooltip text={_('generalsettings.form.branding_header_info')} className="ml-1" />
            </S.Header>
            <FileUpload
                name="virtual.logo"
                accept={IMAGE_ONLY}
                label={_('generalsettings.form.logo')}
                helperText={_('generalsettings.form.logo_helper_text')}
                maxImageSize={{ width: 400, height: 100 }}
            />
            <FileUpload
                name="virtual.backgroundImage"
                accept={IMAGE_ONLY}
                label={_('generalsettings.form.background_image')}
                helperText={_('generalsettings.form.background_image_helper_text')}
            />
            <ColorField
                name="primaryBrandColor"
                label={_('generalsettings.form.primary_brand_color')}
                helperText={_('generalsettings.form.primary_brand_color_helper_text')}
                lg={1/2}
                defaultValue="#ececec"
            />
            <Col lg={6} />
            {!isLite && (
                <>
                    <TextField
                        name="virtual.introVideo"
                        label={_('generalsettings.form.intro_video')}
                        lg={1/2}
                    />
                    <S.AutostartVideoSwitch
                        name="virtual.autostartIntroVideo"
                        label={_('generalsettings.form.autostart_intro_video')}
                        lg={1/2}
                    />
                </>
            )}
            <Divider extend={10} marginTop={-10} />
            <S.Header>
                {_('generalsettings.form.landing_header')}
                <InfoTooltip text={_('generalsettings.form.landing_header_info')} className="ml-1" />
            </S.Header>
            <Editor name="virtual.introText" label={_('generalsettings.form.intro-text')} />
            <Editor name="virtual.loginFormAddendum" label={_('generalsettings.form.login_form_addendum')} />
            <Divider extend={10} marginTop={-10} />
            <S.Header>
                {_('generalsettings.form.legal_header')}
                <InfoTooltip text={_('generalsettings.form.legal_header_info')} className="ml-1" />
            </S.Header>
            <Editor name="terms" label={_('generalsettings.form.terms')} />
            <Editor name="privacyStatement" label={_('generalsettings.form.privacyStatement')} />
        </>
    )
}

export default Communication
